// https://github.com/anycable/anycable-client?tab=readme-ov-file#initialization

import { createCable } from '@anycable/web';

export default createCable();
